import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, MapPin, BookOpen, Sparkles, ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-12 pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden" data-id="element-135">
      {/* Background glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-brand-violet/20 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-136" />

      <div className="text-center max-w-4xl mx-auto" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-8" data-id="element-138">
          <div className="w-2 h-2 rounded-full bg-brand-violet animate-pulse" data-id="element-139" />
          <span className="text-sm font-medium tracking-wide text-brand-violet uppercase" data-id="element-140">
            AURA BIT™
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight text-balance" data-id="element-141">
          Todo lo que necesitás saber sobre IA para tu negocio.{' '}
          <br className="hidden md:block" data-id="element-142" />
          <span className="text-brand-violet" data-id="element-143">Listo. Desde hoy.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="mb-12" data-id="element-144">
          <p className="text-xl md:text-2xl text-gray-300 mb-2 font-medium" data-id="element-145">
            🤖 MEGAPACK IA EMPRENDEDORES™
          </p>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-146">
            El sistema N°1 de IA aplicada a negocios para emprendedores
            argentinos. Ventas + Atención + Marketing + Automatización +
            Finanzas + Escala
          </p>
        </motion.div>

        {/* MOCKUP IMAGE - PROMINENT PLACEMENT */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="relative max-w-[700px] mx-auto mb-16" data-id="element-147">
          <div className="absolute inset-0 bg-brand-violet/20 blur-[60px] rounded-full -z-10" data-id="element-148" />
          <img src="https://cdn.magicpatterns.com/uploads/461MUDBqp4cfdgmPWTkW7m/hf_20260525_183422_b59c1397-fab9-4904-8f34-c78bac23b93c.png" alt="Megapack IA Emprendedores - El pack más completo con 6 tomos" className="w-full h-auto drop-shadow-2xl" data-id="element-149" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-150">
          {[{
          icon: FileText,
          text: '100% PDF'
        }, {
          icon: Zap,
          text: 'Acceso en 5 min'
        }, {
          icon: MapPin,
          text: 'Hecho para Argentina'
        }, {
          icon: BookOpen,
          text: '6 Tomos + 6 Bonos'
        }, {
          icon: Sparkles,
          text: 'Más de 63 prompts listos'
        }].map((badge, i) => <span key={i} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-white/5 border border-white/10 text-sm text-gray-300" data-id="element-151">
              <badge.icon className="w-4 h-4 text-brand-violet" data-id="element-152" />
              {badge.text}
            </span>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="flex flex-col items-center gap-6" data-id="element-153">
          <a href="#pricing" className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 text-lg font-bold text-white bg-brand-red hover:bg-red-600 rounded-xl transition-all hover:scale-105 active:scale-95 shadow-[0_0_20px_rgba(229,57,53,0.4)]" data-id="element-154">
            🔴 → QUIERO MI MEGAPACK IA AHORA
          </a>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400" data-id="element-155">
            <span className="flex items-center gap-2" data-id="element-156">
              <ShieldCheck className="w-4 h-4 text-brand-green" data-id="element-157" />
              Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-158">
              <Lock className="w-4 h-4 text-brand-violet" data-id="element-159" />
              Pago seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-160">
              <CreditCard className="w-4 h-4 text-brand-gold" data-id="element-161" />
              Mercado Pago | Tarjeta | Transferencia
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}